import { useState, useEffect } from "react";
import { noneProfile } from "assets";
import { Service } from "utils/services";
import { Link, useNavigate } from "react-router-dom";
import { RouteUrl } from "utils";
import appStore from "store/appStore";

export default function ImageUrlProfileStoryAndLive({
  user,
  className,
  alt = "",
  isThumbnail = true,
  isLinkProfile = false,
  tmpRouteUrl = null,
}: {
  user: any;
  className?: string;
  alt?: string;
  isThumbnail?: boolean;
  isLinkProfile?: boolean;
  tmpRouteUrl?: string | null;
}) {
  const { onOpenDialogPostModal, onOpenDialogViewStoryModal } = appStore();

  const [imageSrc, setImageSrc] = useState<string>(noneProfile);
  const navigate = useNavigate();

  // * story
  const noOfStory = Service.toInteger(user?.no_of_story);
  const noOfViewStory = Service.toInteger(user?.no_of_view_story);

  const radius = 45;
  const circumference = 2 * Math.PI * radius;
  const segmentSize = circumference / noOfStory;
  const spaceBetweenSegments = 7;
  const adjustedSegmentSize = segmentSize - spaceBetweenSegments;

  useEffect(() => {
    if (!user || user === "") {
      setImageSrc(noneProfile);
    } else {
      let updatedSrc = isThumbnail ? user?.thumbnail ?? "null" : user?.picture ?? "null";

      if (Service.applicationMode.isDebug() && !updatedSrc && updatedSrc !== "") {
        updatedSrc = updatedSrc.replace("https", "http");
      }
      setImageSrc(updatedSrc);
    }
  }, [user, isThumbnail]);

  const handleError = () => {
    setImageSrc(!user ? noneProfile : !user?.avatar || user?.avatar === "" || user?.avatar === "null" ? noneProfile : `/${user?.avatar}`);
  };

  const getLinkPath = () => {
    if (isLinkProfile === true) {
      if (user?.last_active_live_id) {
        // if (tmpRouteUrl) return "#";
        return `${RouteUrl.profilePostContentsPageView}?post_id=${user?.last_active_live_id}`;
      } else if (noOfStory > 0) {
        // if (tmpRouteUrl) return "#";
        return `${RouteUrl.viewStories}?user_id=${user?.id}`;
      }

      return `${RouteUrl.profile}?id=${user?.id}`;
    } else {
      return "#";
    }
  };

  const handleClickOpenModal = () => {
    if (isLinkProfile === true) {
      if (tmpRouteUrl) {
        if (user?.last_active_live_id) {
          onOpenDialogPostModal(user?.last_active_live_id, tmpRouteUrl);
        } else if (noOfStory > 0) {
          onOpenDialogViewStoryModal(user?.id, tmpRouteUrl);
        }
      } else {
        if (user?.last_active_live_id) {
          navigate(`${RouteUrl.profilePostContentsPageView}?post_id=${user?.last_active_live_id}`);
        } else if (noOfStory > 0) {
          navigate(`${RouteUrl.viewStories}?user_id=${user?.id}`);
        } else {
          navigate(`${RouteUrl.profile}?id=${user?.id}`);
        }
      }
    }
  };

  return (
    <Link
      className={`flex flex-col items-center space-y-2 ${isLinkProfile ? " cursor-pointer " : ""}`}
      to={getLinkPath()}
      onClick={(e) => {
        if (e.ctrlKey || e.metaKey || e.button === 1) {
          return;
        }
        e.preventDefault();
        console.log("Navigation prevented.");
        handleClickOpenModal();
      }}
    >
      <div className={`relative p-1 ${className}`}>
        <svg className="absolute inset-0 w-full h-full" viewBox="0 0 100 100">
          {/* live */}
          {user?.last_active_live_id && <circle cx="50" cy="50" r={radius} fill="none" stroke="#ef4444" strokeWidth="4" />}

          {/* story */}

          {!user?.last_active_live_id &&
            Array.from({ length: noOfStory }).map((_, index) => {
              const isViewed = index < noOfViewStory;
              const offset = index * segmentSize; // Position each segment
              return (
                <circle
                  key={index}
                  cx="50"
                  cy="50"
                  r={radius}
                  fill="none"
                  stroke={isViewed ? "#a1a1aa" : "url(#gradient)"} // Gray if viewed, green if unviewed
                  strokeWidth="4"
                  strokeDasharray={`${adjustedSegmentSize} ${circumference - adjustedSegmentSize}`}
                  strokeDashoffset={-offset} // Position segment correctly
                  strokeLinecap="round"
                />
              );
            })}

          {/* Gradient Definition */}
          <defs>
            <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#4ade80" /> {/* Green */}
              <stop offset="100%" stopColor="#3b82f6" /> {/* Blue */}
            </linearGradient>
          </defs>
        </svg>

        {/* Profile Image */}
        <div className="w-full h-full rounded-full overflow-hidden border-2 ">
          <img className="w-full h-full object-cover rounded-full" src={imageSrc} alt={alt} onError={handleError} />

          {/* LIVE badge */}
          {user?.last_active_live_id && (
            <div className="absolute -bottom-1 left-1/2 -translate-x-1/2 px-1 py-[1px] rounded-sm bg-red-600 text-white text-[10px] font-semibold shadow">LIVE</div>
          )}
        </div>
      </div>
    </Link>
  );
}

